import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_4 = { class: "w-8/12 py-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Parameter Perhitungan ", -1)
const _hoisted_6 = { class: "my-1 text-black-lp-300 text-12px font-normal flex flex-row" }
const _hoisted_7 = { class: "text-center rounded px-2 py-0 bg-gray-lp-200 mr-2" }
const _hoisted_8 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_9 = { class: "w-full mr-5 mb-10" }
const _hoisted_10 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Status ", -1)
const _hoisted_12 = { class: "my-1 font-normal" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Diperbarui ", -1)
const _hoisted_17 = { class: "my-1 font-normal" }
const _hoisted_18 = { class: "text-gray-lp-500" }
const _hoisted_19 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Dibuat ", -1)
const _hoisted_21 = { class: "my-1 font-normal" }
const _hoisted_22 = { class: "text-gray-lp-500" }
const _hoisted_23 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV1 = _resolveComponent("TableV1")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.dataDetail.commodityName,
    loading: _ctx.isLoading,
    error: !!_ctx.errorCause,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.getDetail
  }, {
    data: _withCtx(() => [
      _createVNode(_component_DataWrapper, {
        label: "Biaya Tambahan ID",
        value: _ctx.dataDetail.id
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Nama Komoditas",
        value: _ctx.dataDetail.commodityName
      }, null, 8, ["value"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          class: "w-4/12",
          label: "Kota Asal",
          value: _ctx.dataDetail.originCityName
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-6/12",
          label: "Kota Tujuan",
          value: _ctx.dataDetail.destinationCityName
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          class: "w-4/12",
          label: "Tanggal Mulai",
          value: _ctx.formatDateString(_ctx.dataDetail.startedAt)
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          class: "w-6/12",
          label: "Tanggal Berakhir",
          value: _ctx.formatDateString(_ctx.dataDetail.expiredAt)
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          class: "w-4/12",
          label: "Tipe Biaya",
          value: _ctx.tipeBiaya
        }, null, 8, ["value"]),
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.quantifier
                .split(',')
                .map(string =>
                  string
                    .split('_')
                    .map(string =>
                      string
                        ? string.charAt(0).toUpperCase() + string.slice(1)
                        : ''
                    )
                    .join(' ')
                ), (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode("div", _hoisted_7, _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_TableV1, {
            columns: _ctx.columns,
            data: _ctx.dataTiers
          }, null, 8, ["columns", "data"])
        ])
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", {
              class: `rounded-full px-2 py-0 font-medium ${_ctx.styleStatus(_ctx.dataDetail.status)}`
            }, [
              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.statusTitle(_ctx.dataDetail.status)), 1)
            ], 2)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDate(_ctx.dataDetail.updatedAt || _ctx.dataDetail.createdAt)), 1),
        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.dataDetail.updatedBy), 1)
      ]),
      _createVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDate(_ctx.dataDetail.createdAt)), 1),
        _createVNode("div", _hoisted_22, _toDisplayString(_ctx.dataDetail.createdBy), 1)
      ]),
      _createVNode("div", _hoisted_23, [
        (_ctx.isEditAble && _ctx.statusEditable)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              customClass: "px-1 sm:px-12 py-2.5 text-red-lp-100",
              outline: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goEdit(_ctx.id))),
              title: "Ubah"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}